import React from "react";
import ApplyingStampDomain from "../domain/applyingStampDomain";
import ApplyingHolidayDomain from "../domain/applyingHolidayDomain";
import ApplyingOvertimeDomain from "../domain/applyingOvertimeDomain";
import ApplyingHolidayWorkDomain from "../domain/applyingHolidayWorkDomain";
import ApplyingTransferDomain from "../domain/applyingTransferDomain";
import ApplyingAllowanceDomain from "../domain/applyingAllowanceDomain";
import StampAccordion from "./StampAccordion";
import HolidayAccordion from "./HolidayAccordion";
import OvertimeAccordion from "./OvertimeAccordion";
import HolidayWorkAccordion from "./HolidayWorkAccordion";
import TransferAccordion from "./TransferAccordion";
import AllowanceAccordion from "./AllowanceAccordion";

const ApplyingTab: React.FC<{
  stampList: ApplyingStampDomain[];
  holidayList: ApplyingHolidayDomain[];
  overtimeList: ApplyingOvertimeDomain[];
  holidayWorkList: ApplyingHolidayWorkDomain[];
  transferList: ApplyingTransferDomain[];
  allowanceList: ApplyingAllowanceDomain[];
  
  fetchApprovedStampList: any;
  fetchApprovedHolidayList: any;
  fetchApprovedOvertimeList: any;
  fetchApprovedHolidayWorkList: any;
  fetchApprovedTransferList: any;

  fetchRejectedStampList: any;
  fetchRejectedHolidayList: any;
  fetchRejectedOvertimeList: any;
  fetchRejectedHolidayWorkList: any;
  fetchRejectedTransferList: any;
  fetchApprovedAllowanceList: any;
  fetchRejectedAllowanceList: any;

  setApplyingTransferList: any;
  setApplyingStampList: any;
  setApplyingHolidayList: any;
  setApplyingOvertimeList: any;
  setApplyingHolidayWorkList: any;
  setApplyingAllowanceList: any;
}> = ({
  stampList,
  holidayList,
  overtimeList,
  holidayWorkList,
  transferList,
  allowanceList,
  
  fetchApprovedStampList,
  fetchApprovedHolidayList,
  fetchApprovedOvertimeList,
  fetchApprovedHolidayWorkList,
  fetchApprovedTransferList,
  
  fetchRejectedStampList,
  fetchRejectedHolidayList,
  fetchRejectedOvertimeList,
  fetchRejectedHolidayWorkList,
  fetchRejectedTransferList,
  fetchApprovedAllowanceList,
  fetchRejectedAllowanceList,

  setApplyingTransferList,
  setApplyingStampList,
  setApplyingHolidayList,
  setApplyingOvertimeList,
  setApplyingHolidayWorkList,
  setApplyingAllowanceList
}) => {
  return (
    <div>
      <StampAccordion
        list={stampList}
        setApplyingStampList={setApplyingStampList}
        fetchApprovedList={fetchApprovedStampList}
        fetchRejectedList={fetchRejectedStampList}
      />

      <HolidayAccordion
        list={holidayList}
        setApplyingHolidayList={setApplyingHolidayList}
        fetchApprovedList={fetchApprovedHolidayList}
        fetchRejectedList={fetchRejectedHolidayList}
      />

      <OvertimeAccordion
        list={overtimeList}
        setApplyingOvertimeList={setApplyingOvertimeList}
        fetchApprovedList={fetchApprovedOvertimeList}
        fetchRejectedList={fetchRejectedOvertimeList}
      />

      <HolidayWorkAccordion
        list={holidayWorkList}
        setApplyingHolidayWorkList={setApplyingHolidayWorkList}
        fetchApprovedList={fetchApprovedHolidayWorkList}
        fetchRejectedList={fetchRejectedHolidayWorkList}
      />

      <TransferAccordion
        list={transferList}
        setApplyingTransferList={setApplyingTransferList}
        fetchApprovedList={fetchApprovedTransferList}
        fetchRejectedList={fetchRejectedTransferList}
      />

      {/* 手当申請は最後（承認済・否決済タブと同じ並びにそろえる） */}
      <AllowanceAccordion
        list={allowanceList}
        setApplyingAllowanceList={setApplyingAllowanceList}
        fetchApprovedList={fetchApprovedAllowanceList}
        fetchRejectedList={fetchRejectedAllowanceList}
      />
    </div>
  );
};

export default ApplyingTab;
